<template>
	<div class="nav" v-if="user">
		<div class="container-xl d-flex">
			<div class="nav-brand">
				<img src="@/assets/logo.png" alt="Ceara" />
			</div>
			<div>
				<div class="nav-user">
					<span class="nav-user-name">{{ user.name }}</span>
					<btn size="xs" class="btn-lgrey" @click.prevent="$store.dispatch('LOGOUT')">SALIR</btn>
				</div>
				<div class="nav-session">
					<div class="nav-data">
						<span class="ico ico-date ico-lg">{{ date }}</span>
						<span class="ico ico-time ico-lg">{{ time }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Btn from './Btn.vue'

	var week = ['DOM', 'LUN', 'MAR', 'MIER', 'JUE', 'VIE', 'SAB']
	var year = [
		'ENERO',
		'FEBRERO',
		'MARZO',
		'ABRIL',
		'MAYO',
		'JUNIO',
		'JULIO',
		'AGOSTO',
		'SEPTIEMBRE',
		'OCTUBRE',
		'NOVIEMBRE',
		'DICIEMBRE'
	]

	function padding0(num, digit) {
		var zero = ''
		for (var i = 0; i < digit; i++) {
			zero += '0'
		}
		return (zero + num).slice(-digit)
	}

	export default {
		components: { Btn },

		name: 'Nav',

		computed: {
			user() {
				return this.$store.state.user
			}
		},

		data() {
			return {
				time: '',
				date: ''
			}
		},

		methods: {
			updateTime() {
				var cd = new Date()
				this.time =
					padding0(cd.getHours(), 2) + ':' + padding0(cd.getMinutes(), 2) + ':' + padding0(cd.getSeconds(), 2)
				this.date =
					week[cd.getDay()] +
					', ' +
					padding0(cd.getDate(), 2) +
					' ' +
					year[cd.getMonth()] +
					' ' +
					padding0(cd.getFullYear(), 4)
			}
		},

		created() {
			this.updateTime()

			setInterval(this.updateTime, 1000)
		}
	}
</script>
